module.exports = __webpack_public_path__ + "public/images/blob-middle.f00194f667f538298cf8176f7c7359cf.png";